/**
 * The responsive breakpoint system for the whole app (UI revamp, 2026-06).
 *
 * Values intentionally match Chakra UI's defaults so declaring them here does
 * NOT reflow any existing `base/md/lg/xl` usage — this file's job is to make the
 * scale EXPLICIT and give each stop a documented semantic meaning so the
 * screen-by-screen responsive pass has one shared vocabulary instead of ad-hoc
 * per-file guesses.
 *
 *   token   min-width        target devices
 *   ------  ---------------   ------------------------------------------------
 *   base    0                 phone, portrait (single column, stacked, drawer nav)
 *   sm      30em / 480px      phone, landscape / large phone
 *   md      48em / 768px      tablet, portrait (forms go 2-up, gutters widen)
 *   lg      62em / 992px      tablet landscape / small laptop
 *   xl      80em / 1280px     desktop — the fixed sidebar appears here
 *   2xl     96em / 1536px     wide desktop (content caps at maxW, extra gutter)
 *
 * The chrome (SidebarWithHeader) switches from drawer to fixed sidebar at `xl`;
 * keep that contract in mind when choosing where content should change layout.
 */
const breakpoints = {
  sm: '30em',
  md: '48em',
  lg: '62em',
  xl: '80em',
  '2xl': '96em',
};

export default breakpoints;
